<template>
  <div>
    <!-- 查看详情弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="列表详情"
      :visible.sync="infoDialogVisible"
      :before-close="infoHandleClose"
      width="1600px"
      center
      top="5vh"
    >
      <el-divider></el-divider>
      <div class="infoForm">
        <div class="top_titles">
          <div>
            正在下单：<span>{{info.nowNum}}/{{info.totalNum}}</span>
          </div>
          <div>
            下单成功：<span>{{info.successNum}}</span>
          </div>
          <div>
            下单失败：<span>{{info.failNum}}</span>
          </div>
          <div  v-if="info.failNum>0"  style="color:red;cursor: pointer; font-size:1.8rem" @click="shibais">
              点击产看失败原因
          </div>
        </div>
          <div style="margin-top:1.8rem;">
            <el-table
              :data="table"
              :header-cell-style="tableHeaderColor"
              :cell-style="cellStyle"
              style="width: 100%"
            >
              <el-table-column prop="CreateTime" label="下单时间"  >
              </el-table-column>
              <el-table-column prop="OrderNumber" label="订单号"  >
              </el-table-column>
              <el-table-column prop="OrderCode" label="消费码"  >
              </el-table-column>
              <el-table-column prop="OnlyCode" label="第三方订单号"  >
              </el-table-column>
              <el-table-column label="订单内容" width="400">
                <template slot-scope="scope">
                    <div class="orderContent" v-for="(item,index) in scope.row.order_detail" :key="index">
                      <span>{{item.OrderAll.productname}}</span>
                      <span v-if="item.OrderAll.type==1">游玩时间：{{item.playdate}}</span>
                      <span v-if="item.OrderAll.type==0">游玩时间：{{item.OrderAll.consumebegindate}}--{{item.OrderAll.consumeenddate}}</span>
                      <span>游客名称：{{scope.row.consumer}}  联系电话：{{scope.row.Mobile}}</span>
                    </div>
                </template>
              </el-table-column>
              <el-table-column prop="ActFee" label="订单金额"  >
              </el-table-column>
              <el-table-column prop="CreateTime" label="订单状态"  >
                <template slot-scope="scope">
                    {{ scope.row.type=='0'?'未验票':scope.row.type=='1'?'已验票':'退票' }}
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination">
            <span class="demonstration">共{{total}}条记录，</span>
            <span class="demonstration">当前显示第{{data.page}}页</span>
            <el-pagination background layout="prev, pager, next" :page-size="data.page_size" :total="total" :current-page.sync="data.page"  @current-change="currenchange"></el-pagination>
          </div>
      </div>
      

    </el-dialog>
    <!-- 查看详情弹框结束 -->
    <el-dialog :close-on-click-modal="false"
        title="失败原因"
        :visible.sync="errVisible"
        :before-close="errClose"
        width="800px"
        center
        top="5vh"
      >
      <div class="infoForm">
          <div style="margin-top:1.8rem;">
            <el-table
              :data="info.failReason"
              :header-cell-style="tableHeaderColor"
              :cell-style="cellStyle"
              style="width: 100%"
            >
              <el-table-column prop="phone" label="下单手机号"  >
              </el-table-column>
              <el-table-column prop="create_time" label="下单时间"  >
              </el-table-column>
              <el-table-column prop="error_msg" label="失败原因"  >
              </el-table-column>
            </el-table>
          </div>
      </div>
      </el-dialog>
  </div>
</template>

<script>
import {getScenicBatchOrderList,getBatchResultData} from '@/request/scenic.js'
export default {
  props:['order_id'],
  data() {
    return {
      infoDialogVisible: false, // 产品详情
      table:[],
      total:0,
      data:{
        token:window.sessionStorage.getItem('Token'),
        Mobile:'',
        OrderNumber:"",
        start_time:"",
        end_time:"",
        status:"",
        page:1,
        page_size:8,
        ScenicID:"",
        batch:''
      },
      info:'',
      errVisible:false,

    };
  },
  created(){
    this.detail()
  },
  methods: {
    errClose(){
      this.errVisible = false
    },
    shibais(){
      this.errVisible = true
    },
    currenchange(e){
      this.data.page = e
      this.detail()
    },
    // 订单详情
    detail(){
      this.data.batch = this.order_id
      getScenicBatchOrderList(this.data).then(res=>{
        if(res.data.status=='ok'){
            this.table  = res.data.result.data
            this.total = res.data.result.total
        }
      })
      let data = {
        token:window.sessionStorage.getItem('Token'),
        batch:this.data.batch
      }
      getBatchResultData(data).then(res=>{
        if(res.data.status=='ok'){
            this.info = res.data.data
        }
      })
    },
    // 产品详情
    Info() {
      this.infoDialogVisible = true;
    },
    // 产品详情
    infoHandleClose() {
      this.infoDialogVisible = false;
      this.$emit('CloseGb')
    },
     // 表头设置
     tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.infoForm{
  box-sizing: border-box;
  .form_input{
    width: 100%;
    display: flex;
    align-items: center;
    .input_box{
      display: flex;
      align-items: center;
      margin-right: 1.9rem;
      /deep/.el-input{
        width: 22.2rem;
      }
      span{
        color: #666;
        text-align: right;
        font-family: OPPOSans;
        font-size: 1.4rem;
        display: block;
        width: 8.4rem;
      }
    }
    .notes{
      flex: 1;
      display: flex;
      align-items: center;
      /deep/.el-input{
        width: 90%;
      }
      span{
        color: #666;
        text-align: right;
        font-family: OPPOSans;
        font-size: 1.4rem;
        display: block;
        width: 5rem;
      }
    }
  }
  .orderNumbers{
    display: flex;
    align-items: center;
    margin-top: 3rem;
    div{
      color: #666;
      font-family: OPPOSans;
      font-size: 1.4rem;
      font-style: normal;
      font-weight: 400;
      margin-right: 2rem;
    }
  }
}
.bottom_button{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1.5rem;
  div{
    width: 10rem;
    height: 4rem;
    border-radius: 0.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #246DEB;
    color: #fff;
    color: #FFF;
    text-align: center;
    font-size: 1.4rem;
    margin-right: 2rem;
    
  }
}
/deep/.el-input__inner{
  background: #fff !important;
  color: #666 !important;
}
.orderContent{
  display: flex;
  flex-direction: column;
}
.orderContent span{
  text-align: left;
  color: #000000;
  font-size: 1.4rem;
  margin-bottom: 2px;
  &:nth-child(1){
    color: #468BC8;
  }
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin:3.2rem auto 1rem auto ;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
.top_titles{
  display: flex;
  align-items: center;
  div{
    color: #000000;
    font-size: 1.4rem;
    align-items: center;
    display: flex;
    &:nth-child(n+2){
      margin-left: 3.4rem;
    }
    span{
      color: #246DEB;
      display: block;
    }
  }
}
</style>